<template>
    <div class="page-item-info-vr">
        <div class="page-item-info-vr__anchor"
            id="page-item-info-vr"
        />
        <div class="page-item-info-vr__content">
            <div class="page-item-info-vr__content-title">
                <a class="page-item-info-vr__content-title-link"
                   v-bind:href="modalUrl"
                >
                    Виртуальная примерка
                </a>
            </div>
            <div class="page-item-info-vr__content-description"
                v-text="description"
            />
            <a class="page-item-info-vr__content-button"
                v-bind:href="modalUrl"
                >
                <ui-button isUppercase>
                    Примерить
                </ui-button>
            </a>
        </div>
        <div class="page-item-info-vr__images">
            <a v-bind:href="modalUrl">
                <img class="page-item-info-vr__images-item"
                     v-bind:src="staticPathRoot + '/images/vr-banner-v1.png'"
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-item-info-vr',
    inject: [ 'staticPathRoot' ],
    props: {
        title: {
            type: String,
        },
        vrModelName: {
            type: String,
        },
    },
    computed: {
        modalUrl() {
            return `#armodal=${this.vrModelName}`;
        },
        description() {
            return `Примерьте оправу ${this.title} прямо на сайте`;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-item-info-vr {
    position: relative;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    &__anchor {
        display: block;
        position: absolute;
        top: -64px;
    }
    &__content {
        flex: 0 0 auto;
        width: 33.33%;
        padding: 16px;
        &-title {
            .typography-display-md();

            margin-bottom: 36px;

            text-transform: uppercase;
        }
        &-description {
            .typography-display-md();

            margin-bottom: 24px;
        }
        &-button {
            display: block;
            width: 140px;

            text-decoration: none;
        }
    }
    &__images {
        flex: 1 1 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 42px 42px 42px 0;

        &-item {
            aspect-ratio: 19/7;
        }
    }
    @media @media-lg-down {
        &__content {
            flex: 0 0 auto;
            width: 33.33%;
            padding: 16px;
            &-title {
                .typography-display-sm();

                margin-bottom: 28px;
            }
            &-description {
                .typography-display-sm();

                margin-bottom: 16px;
            }
        }
    }
    @media @media-md-down {
        flex-direction: column-reverse;
        &__anchor {
            top: -104px;
        }
        &__content {
            width: 100%;
            &-description {
                max-width: 335px;
            }
        }
        &__images {
            padding: 16px;
        }
    }
}
</style>
